import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CognitoService } from 'app/shared/services/cognito.service';

export const authGuard: CanActivateFn = async () => {
  const cognitoService = inject(CognitoService);
  const router = inject(Router);

  const isAuthenticated = await cognitoService.isAuthenticated();
  if (isAuthenticated) {
    router.navigate(['']).then(() => {});
  }
  return !isAuthenticated;
};
